import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { CssBaseline, GlobalStyles } from '@mui/material';
import ResponsiveNavbar from "./components/ResponsiveNavbar";
import ResponsiveLayout from "./components/ResponsiveLayout";
import IndexPage from "./pages/index";
import AboutPage from "./pages/about";
import FaqPage from "./pages/faq";
import ContactPage from "./pages/contact";
import PricingPage from "./pages/pricing";
import AuthPage from "./pages/auth";
import SettingsPage from "./pages/settings";
import LegalPage from "./pages/legal";
import PurchasePage from "./pages/purchase";
import FirebaseActionPage from "./pages/firebase-action";
import NotFoundPage from "./pages/404";
import BonusAI from "./pages/BonusAI";
import BonusWatcher from "./pages/BonusWatcher";
import BankDetails from "./pages/BankDetails";
import Leaderboard from './pages/Leaderboard';
import Friends from "./pages/Friends";
import { RequireAuth, useAuth } from "./util/auth";
import Profile from './pages/Profile';
import Login from './pages/Login';
import Admin from './pages/Admin';
import SignUp from './pages/auth/signup';
import SignIn from './pages/auth/signin';

// Component to handle root path - redirects authenticated users to /bonus-watcher
function RootRedirect() {
  const { user, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (user) {
    return <Navigate to="/bonus-watcher" replace />;
  }

  return <IndexPage />;
}

function App() {
  return (
    <>
      <CssBaseline />
      <GlobalStyles
        styles={{
          'html, body': {
            overflowX: 'hidden',
            width: '100%',
            height: '100%',
            margin: 0,
            padding: 0,
          },
          '#root': {
            width: '100%',
            height: '100%',
            overflow: 'hidden',
          },
          '.MuiContainer-root': {
            paddingLeft: '0 !important',
            paddingRight: '0 !important',
            padding: '0 !important',
            margin: '0 !important',
            maxWidth: '100% !important',
          },
        }}
      />
      <Routes>
        {/* Auth routes without navbar/layout */}
        <Route exact path="/auth/signup" element={<SignUp />} />
        <Route exact path="/auth/signin" element={<SignIn />} />

        {/* All other routes with navbar/layout */}
        <Route path="*" element={
          <>
            <ResponsiveNavbar />
            <ResponsiveLayout>
              <Routes>
                <Route exact path="/" element={<RootRedirect />} />
                <Route exact path="/about" element={<AboutPage />} />
                <Route exact path="/faq" element={<FaqPage />} />
                <Route exact path="/contact" element={<ContactPage />} />
                <Route exact path="/pricing" element={<PricingPage />} />
                <Route exact path="/dashboard" element={<Navigate to="/bonus-watcher" replace />} />
                <Route exact path="/auth/:type" element={<AuthPage />} />
                <Route exact path="/settings/:section" element={
                  <RequireAuth>
                    <SettingsPage />
                  </RequireAuth>
                } />
                <Route exact path="/legal/:section" element={<LegalPage />} />
                <Route exact path="/purchase/:plan" element={<PurchasePage />} />
                <Route exact path="/firebase-action" element={<FirebaseActionPage />} />
                <Route path="/bonus-ai" element={
                  <RequireAuth>
                    <BonusAI />
                  </RequireAuth>
                } />
                <Route path="/bonus-watcher" element={
                  <RequireAuth>
                    <BonusWatcher />
                  </RequireAuth>
                } />
                <Route path="/bank/:bankId" element={
                  <RequireAuth>
                    <BankDetails />
                  </RequireAuth>
                } />
                <Route path="/leaderboard" element={
                  <RequireAuth>
                    <Leaderboard />
                  </RequireAuth>
                } />
                <Route path="/friends" element={
                  <RequireAuth>
                    <Friends />
                  </RequireAuth>
                } />
                <Route path="/profile" element={
                  <RequireAuth>
                    <Profile />
                  </RequireAuth>
                } />
                <Route path="/admin" element={
                  <RequireAuth>
                    <Admin />
                  </RequireAuth>
                } />
                <Route path="/login" element={<Login />} />
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            </ResponsiveLayout>
          </>
        } />
      </Routes>
    </>
  );
}

export default App; 